/* ============
 * All License Types
 * ============
 *
 * All license types.
 */

import Vue from 'vue';
import store from '../../store';
import licenseTypeTransformer from '../../transformers/licenseType';

const success = ({ data }, resolve) => {
  const licenseTypes = licenseTypeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllLicenseTypes', licenseTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display license types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('license/types')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/licenseType/all.js